/**
 * @author Andrés Camilo Ferreira Rodríguez
 * @Copyright (c) Infotrack. All rights reserved.
 */
export default {
  'sidebar.smartstock': 'Smart Stock',
  'sidebar.resolucionesfacturaciones': 'Resoluciones Facturaciones',
  'resolucionesFacturaciones.agregarResolucionesFacturaciones': 'Crear Resoluciones Facturaciones',
  'resolucionesFacturaciones.modificarResolucionesFacturaciones': 'Editar Resoluciones Facturaciones',
  'resolucionesFacturaciones.resolucionFacturacionId': 'Resolución Facturación Id',
  'resolucionesFacturaciones.empresaId': 'Empresa Id',
  'resolucionesFacturaciones.agenciaId': 'Agencia Id',
  'resolucionesFacturaciones.bodegaId': 'Bodega Id',
  'resolucionesFacturaciones.descripcionResolucionFacturacion': 'Descripción Resolución Facturación',
  'resolucionesFacturaciones.facturaInicio': 'Factura Inicio',
  'resolucionesFacturaciones.facturaFin': 'Factura Fin',
  'resolucionesFacturaciones.facturaActual': 'Factura Actual',
  'resolucionesFacturaciones.fechaInicio': 'Fecha Inicio',
  'resolucionesFacturaciones.fechaFin': 'Fecha Fin',
  'resolucionesFacturaciones.estado': 'Estado',
  'resolucionesFacturaciones.VerResolucionesFacturaciones': 'Ver Resoluciones Facturaciones',
  'resolucionesFacturaciones.bodegaDescripcion': 'Bodega',
};
